var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1555",
    "data-name": "Group 1555",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.507,
    height: 39.67,
    viewBox: "0 0 58.507 39.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 58.507,
    height: 39.67,
    fill: "#434343"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M0,7.3V1.043a1.043,1.043,0,1,1,2.085,0V7.3A1.043,1.043,0,0,1,0,7.3",
    transform: "translate(28.226 4.194)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M.036,4.281a1.037,1.037,0,0,0,1.277.737L12.389,2.05a1.043,1.043,0,0,0-.54-2.014L.773,3A1.043,1.043,0,0,0,.036,4.281Z",
    transform: "translate(45.345 20.641)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M.522,7.362a1.042,1.042,0,0,0,1.424-.383L5.073,1.558A1.043,1.043,0,0,0,3.268.515L.14,5.937A1.042,1.042,0,0,0,.522,7.362Z",
    transform: "translate(37.087 7.432)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M5.943.143.527,3.271h0A1.042,1.042,0,1,0,1.57,5.076L6.991,1.949A1.042,1.042,0,1,0,5.949.143Z",
    transform: "translate(43.569 16.204)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M.307,9.876a1.042,1.042,0,0,0,1.474,0L9.89,1.767h0A1.042,1.042,0,0,0,8.416.293L.3,8.407a1.042,1.042,0,0,0,0,1.469Z",
    transform: "translate(40.761 7.568)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M.776,13.127h0a1.06,1.06,0,0,0,.27.037,1.043,1.043,0,0,0,1.007-.774L5.022,1.313A1.043,1.043,0,0,0,3.008.773L.035,11.85a1.043,1.043,0,0,0,.737,1.277Z",
    transform: "translate(32.813 0)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M.522,1.949,5.943,5.076A1.042,1.042,0,1,0,6.986,3.271L1.57.143A1.042,1.042,0,1,0,.527,1.949Z",
    transform: "translate(7.46 16.204)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M.808,2.058,11.88,5.026a1.042,1.042,0,1,0,.54-2.014L1.343.044A1.043,1.043,0,1,0,.808,2.058Z",
    transform: "translate(0 20.633)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M42.7.2A12.546,12.546,0,0,1,44.825,0c5.436,0,10.27,5.347,13.368,9.833h0a1.043,1.043,0,1,1-1.716,1.184c-2.3-3.336-6.881-8.932-11.652-8.932a10.928,10.928,0,0,0-2.684.348h-.008c-.417.1-.821.233-1.23.375-.112.04-.224.086-.336.127-.282.1-.565.219-.847.34l-.417.183q-.425.194-.85.408l-.313.157c-.356.184-.714.378-1.072.579-.188.1-.375.209-.564.32l-.584.338c-.217.128-.435.256-.654.386l-.135.082-.852.511c-.9.542-1.826,1.086-2.771,1.619h0A18.033,18.033,0,0,0,38.57,9.383a1.042,1.042,0,1,1,0,2.085A21.246,21.246,0,0,1,29.2,9.1l-.013.006-.469-.238c-.064-.031-.123-.069-.187-.1C27.8,8.388,27.088,8,26.394,7.6l-.172-.1c-.683-.4-1.35-.8-2-1.187l-.126-.075q-.834-.5-1.65-.983c-.191-.113-.381-.222-.57-.33S21.494,4.7,21.3,4.6c-.359-.2-.717-.4-1.075-.579-.1-.053-.208-.1-.307-.151q-.429-.216-.861-.417-.2-.092-.407-.179c-.285-.123-.569-.237-.855-.343-.109-.04-.218-.086-.329-.124a8.126,8.126,0,0,0-.934-.3l-.305-.079h0a10.934,10.934,0,0,0-2.684-.34c-4.77,0-9.348,5.6-11.652,8.932A1.043,1.043,0,0,1,.18,9.833C3.279,5.35,8.113,0,13.549,0h0a12.545,12.545,0,0,1,2.128.2l.887.116a1.95,1.95,0,0,1,.415.1l.751.274a.24.24,0,0,0,.063.026A23.169,23.169,0,0,1,21.354,2.26l.342.183c.489.264.979.536,1.468.821l.291.168q.851.5,1.709,1.017l.267.158q.713.431,1.442.859c.188.1.378.217.567.325q.674.388,1.364.757c.126.068.253.134.381.2q.672-.351,1.331-.73c.209-.116.417-.224.616-.342.7-.408,1.4-.822,2.078-1.233q.865-.521,1.719-1.023l.272-.157q.738-.428,1.477-.826l.341-.182A23.014,23.014,0,0,1,40.581.716l.074-.023Z",
    transform: "translate(0.082 28.196)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M2.053,13.2a11.468,11.468,0,0,1,22.925,0l2.042-.491A13.535,13.535,0,0,0,0,12.712",
    transform: "translate(15.758 15.686)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M3.264,6.979A1.043,1.043,0,1,0,5.07,5.937L1.942.515A1.043,1.043,0,0,0,.136,1.558Z",
    transform: "translate(16.241 7.432)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M8.4,9.87A1.043,1.043,0,1,0,9.876,8.4L1.767.293A1.043,1.043,0,0,0,.293,1.767Z",
    transform: "translate(7.598 7.574)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M3,12.389H3a1.043,1.043,0,0,0,1.007.773,1.059,1.059,0,0,0,.27-.037,1.043,1.043,0,0,0,.737-1.277L2.05.773a1.043,1.043,0,0,0-2.014.54Z",
    transform: "translate(20.671 0)",
    fill: "#434343"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIcon);
export default __webpack_public_path__ + "static/media/modalIcon.a960019509cf27f992a67d6a594d5bf1.svg";
export { ForwardRef as ReactComponent };